export default "__VITE_ASSET__zhS0CD6T__"